module.exports = __webpack_public_path__ + "static/media/image_31.37b4dd5a.png";